export var getIsValidError = function getIsValidError(value, isValid, invalidMessage) {
  var isValueInvalid = !!value && isValid === false;
  return isValueInvalid && (invalidMessage || true);
};